import React from 'react';

import type { LucideIcon } from 'lucide-react';
import { Circle, icons as lucideIcons } from 'lucide-react';

interface LucideIconRendererProps extends Omit<React.ComponentPropsWithoutRef<'svg'>, 'ref'> {
  icon: string;
  color?: string;
  fallback?: React.ReactNode;
  // e.g., "Check", "Star", "Heart"
  iconUrl?: string;
  // For custom icons - URL to image
  size?: number;
  strokeWidth?: number;
}

const lucideIconRegistry: Record<string, LucideIcon> = lucideIcons;

function getLucideIcon(name: string): LucideIcon | undefined {
  return lucideIconRegistry[name];
}

export function LucideIconRenderer({
  className,
  color = 'currentColor',
  fallback,
  icon,
  iconUrl,
  size = 24,
  strokeWidth = 2,
  ...rest
}: LucideIconRendererProps): JSX.Element {
  // If custom icon URL is provided, render as image
  if (iconUrl) {
    return (
      <img
        alt={icon}
        className={className}
        src={iconUrl}
        style={{
          height: size,
          objectFit: 'contain',
          width: size,
        }}
      />
    );
  }

  const IconComponent = getLucideIcon(icon);
  if (!IconComponent) {
    return <>{fallback ?? <Circle color={color} size={size} />}</>;
  }

  return (
    <IconComponent
      className={className}
      color={color}
      size={size}
      strokeWidth={strokeWidth}
      {...rest}
    />
  );
}
